import { createUseStyles } from "react-jss";

export const useSwitchStyles = createUseStyles({
  CheckBoxWrapper: {
    position: "relative",
    height: "auto",
    overflow: "hidden",
    "min-height": "27px",
  },
  CheckBoxLabel: {
    position: "relative",
    display: "block",
    top: "4px",
    left: 0,
    width: "40px",
    height: "14px",
    "border-radius": "15px",
    background: "rgba(218,218,218)",
    cursor: ({ disabled }: { disabled: boolean }) =>
      disabled ? "pointer" : "cursor",
    opacity: ({ disabled }: { disabled: boolean }) => (disabled ? 0.4 : 1),
    float: "left",
    "&::after": {
      content: "''",
      display: "block",
      "border-radius": "50%",
      width: "20px",
      height: "20px",
      margin: "-4px 0 3px",
      background: "rgba(68,68,68)",
      "box-shadow": "1px 3px 3px 1px rgba(0, 0, 0, 0.2)",
      transition: "0.2s",
    },
  },
  ContentWrapper: {
    display: "block",
    "margin-top": "2px",
    "margin-left": "55px",
    "font-family": "sans-serif",
    "max-width": "100%",
    height: "auto",
    overflow: "hidden",
  },
  CheckBox: {
    opacity: 0,
    "z-index": 1,
    "border-radius": "15px",
    width: "100%",
    height: "12px",
    top: "4px",
    left: 0,
    position: "absolute",
    cursor: ({ disabled }: { disabled: boolean }) =>
      disabled ? "default" : "pointer",
    "&:checked + label": {
      background: "rgba(34,34,34)",
      "&::after": {
        background: "rgba(235,71,92)",
        content: "''",
        display: "block",
        "border-radius": "50%",
        width: "20px",
        height: "20px",
        "margin-left": "21px",
        transition: "0.2s",
      },
    },
  },
});
